import React from "react";
import Topbar from "./topbar";
import BillinsTabs from "./billingTabs";
import { Col, Row } from "antd";
import BillingPayDetails from "./billingPayDetails";
import HoldBill from "./holdBill";
import BillingFooter from "./biilingFooter";
import { makeStyles } from "@material-ui/core";
import DraftProvider from "./draftProvider";
import KoTDraftB2bProvider from "./kotDraftB2bProvider";

const useStyles = makeStyles((theme) => ({
  colStyle: {
    flex: "0 0 28%",
    maxWidth: "28%",
  },
}));

const Layout = (props) => {
  const classes = useStyles();
  const [tabKey, setTabKey] = React.useState("1");

  return (
    <>
      <Topbar />
      <Row
        style={{
          background: "#F5F9FC",
          padding: "16px",
          height: "calc(100vh - 79px)",
        }}
        justify="space-between"
      >
        <Col
          span={tabKey === "1" ? 17 : 24}
          style={{
            position: "relative",
          }}
        >
          <BillinsTabs tabKey={tabKey} setTabKey={setTabKey} />
          {tabKey === "1" && <HoldBill />}
          {tabKey === "1" && <BillingFooter />}
        </Col>
        {tabKey === "1" && (
          <Col span={6} className={classes.colStyle}>
            <BillingPayDetails />
          </Col>
        )}
      </Row>
    </>
  );
};

const KOT = (props) => {
  return (
    <DraftProvider>
      <KoTDraftB2bProvider>
        <Layout />
      </KoTDraftB2bProvider>
    </DraftProvider>
  );
};

export default KOT;
